import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch (e) {
        // keep polling
      }
      tries += 1;
      if (tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    if (sessionId) poll();
    else setState("failed");
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center" data-testid="payment-success-page">
      {state === "checking" && (<><Loader2 className="mx-auto animate-spin text-primary" size={48} /><h1 className="font-display text-4xl font-bold mt-8">Confirming payment…</h1></>)}
      {state === "paid" && (
        <>
          <CheckCircle2 className="mx-auto text-primary" size={56} />
          <h1 className="font-display text-4xl sm:text-5xl font-bold mt-8" data-testid="payment-status-paid">You're live!</h1>
          <p className="text-white/60 mt-4">Your profile is now visible in search. If you're on a free trial, nothing is charged until it ends — you can cancel any time from your dashboard.</p>
        </>
      )}
      {(state === "failed" || state === "timeout") && (
        <>
          <XCircle className="mx-auto text-red-400" size={56} />
          <h1 className="font-display text-4xl font-bold mt-8" data-testid="payment-status-failed">{state === "timeout" ? "Still processing" : "Payment not completed"}</h1>
          <p className="text-white/60 mt-4">{state === "timeout" ? "This can take a minute. Check your dashboard shortly." : "No money was taken. You can try again from your dashboard."}</p>
        </>
      )}
      <Link to="/dashboard" className="inline-block mt-10 bg-primary text-primary-foreground px-8 py-4 font-bold uppercase text-sm tracking-wider" data-testid="payment-dashboard-link">Go to dashboard</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center" data-testid="payment-cancel-page">
      <h1 className="font-display text-4xl font-bold">Payment cancelled</h1>
      <p className="text-white/60 mt-4">No money was taken. Your profile is saved — go live whenever you're ready.</p>
      <Link to="/dashboard" className="inline-block mt-10 bg-primary text-primary-foreground px-8 py-4 font-bold uppercase text-sm tracking-wider" data-testid="payment-cancel-dashboard-link">Back to dashboard</Link>
    </div>
  );
}
